// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"176":"projects","177":"home","330":"projects-page","894":"services"}[chunkId] + ".css";
};